import { Provider } from '@angular/core';
import { AUTH_SESSION } from '@shared/di/auth-session.token';
import { AuthService } from './services/auth.service';

/** Binds the shared session port to {@link AuthService}. Register at the root injector. */
export function provideAuthSession(): Provider {
  return { provide: AUTH_SESSION, useExisting: AuthService };
}
